<template>
    <div>
        <ob-modal2 :show.sync="openModal" :type="1" :width="600" :backdrop="false">
            <div class="modal-body TSStyle" >
                <img  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/WarningIcon.png`" style="width:50px; height:50px">
                <h3 v-if="deleteType == 'Timesheet'">Delete Timesheet</h3>
                <h3 v-else>Delete Expense</h3>
                <p>Are you sure you want to delete this <span v-if="deleteType == 'Timesheet'">timesheet?</span><span v-else>expense?</span> Please note that this action is permanent and cannot be undone</p>
                <ob-textarea v-model="reason" :maxLength="900" :class="{ 'ob-vuelidate_error-msg': $v.reason.$error }" class="form-control" :placeholder="placeholderText"></ob-textarea>
                <span class="ob-vuelidate_error-msg error" v-if="$v.reason.$dirty && !$v.reason.required">Please provide a reason</span>
            </div>
        <div class="modal-footer">
                <ob-button type="secondary" @click="deleteMethod">Yes</ob-button>
                <ob-button type="primary" @click="cancel">No</ob-button>
            </div>
        </ob-modal2>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default{
    props:["openDeletetimesheetPopup", "type"],
    data() {
        return{
            openModal : false,
            reason:"",
            deleteType:'',
            placeholderText:''
        }
    },
    watch:{
        openDeletetimesheetPopup(val){
            if(val){
                this.resetValues()
            }
            this.openModal = val
        },
        openModal(val){
            this.$emit('update:openDeletetimesheetPopup', val)
        },
        type(val){
            this.deleteType = val
            if(val == 'Timesheet'){
                this.placeholderText = 'Please provide a reason for deleting the timesheet'
            }
            else{
                this.placeholderText = 'Please provide a reason for deleting the expense'
            }
        }
    },
    validations: {
        reason:{
            required
        }
  },
    methods:{
        deleteMethod(){
            this.$v.reason.$touch()
            if(this.$v.reason.$invalid == false)
            this.$emit("Delete", this.reason, this.deleteType)
        },
        cancel(){
            this.resetValues()
            this.openModal = false
           // this.$emit("cancel")
        },
        resetValues(){
            this.reason = ''
            this.$v.reason.$reset()
        }
    }
}
</script>
<style lang="scss" scoped>
.TSStyle{
    text-align: center;
    padding: 25px
   
}
.TSStyle h3{
    font-size: 16px;
    color: #212121;
    font-weight: 600;
    padding-top: 10px;
}
.TSStyle p{
    font-size: 13px;
color: #424242;
padding-bottom: 20px;
padding-left: 20px;
padding-right: 20px;
}
.TSStyle .error{
    float:left;
    padding-top: 2px;
}
.TSStyle textarea.ob-vuelidate_error-msg{
    border:1px solid #d60000;
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/DeleteTimesheetPopup.vue